import { mutator } from 'satcheljs';
import { onCurrentRouteChanged } from '../actions';
import { getPageStore } from '../store/store';

mutator(onCurrentRouteChanged, (msg) => {
  getPageStore().currentRoute = msg.currentRoute;
});
